import React, { useEffect, useState } from 'react';
import { Button, TableCell, TableRow, Chip, Checkbox } from '@material-ui/core';
import { trim } from 'lodash';
import moment from 'moment';
import LoyaltyRoundedIcon from '@material-ui/icons/LoyaltyRounded';
import MonetizationOnRoundedIcon from '@material-ui/icons/MonetizationOnRounded';
import AssignmentTurnedInRoundedIcon from '@material-ui/icons/AssignmentTurnedInRounded';
import SystemUpdateAltRoundedIcon from '@material-ui/icons/SystemUpdateAltRounded';

const QRCodeStatusText = {
  forSale: '待售',
  link: '已歸戶',
  use: '已使用',
};

const BonusProductQRCodeTableRow = (props) => {
  const { QRCode, isLoading, downloadQRCode } = props;
  const [QRCodeStatus, setQRCodeStatus] = useState();

  useEffect(() => {
    if (QRCode) {
      if (trim(QRCode.useDate) !== '') {
        setQRCodeStatus('use');
      } else if (trim(QRCode.userId) !== '') {
        setQRCodeStatus('link');
      } else {
        setQRCodeStatus('forSale');
      }
    }
  }, [QRCode]);

  const handleDownloadQRCode = () => {
    downloadQRCode(QRCode);
  };

  return (
    <TableRow>
      <TableCell component="th">{QRCode.bonusProductQRCodeId}</TableCell>
      <TableCell component="th">{QRCode.bonusProductInfo.name}</TableCell>
      <TableCell>
        {QRCode.productPackageInfo ? QRCode.productPackageInfo.name : ''}
      </TableCell>

      <TableCell>{QRCode.qRCodeValue}</TableCell>

      <TableCell>
        <Checkbox disabled checked={QRCode.isConsignment} />
      </TableCell>

      <TableCell>
        <Chip
          color={
            QRCodeStatus === 'forSale'
              ? 'default'
              : QRCodeStatus === 'link'
              ? 'primary'
              : 'secondary'
          }
          size="small"
          label={QRCodeStatusText[QRCodeStatus]}
          icon={
            QRCodeStatus === 'forSale' ? (
              <LoyaltyRoundedIcon />
            ) : QRCodeStatus === 'link' ? (
              <MonetizationOnRoundedIcon />
            ) : (
              <AssignmentTurnedInRoundedIcon />
            )
          }
        />
      </TableCell>

      <TableCell>
        {QRCode.customerInfo ? QRCode.customerInfo.realName : ''}
      </TableCell>

      <TableCell>
        {QRCode.linkDate && moment(QRCode.linkDate).format('YYYY-MM-DD')}
      </TableCell>

      <TableCell>
        {QRCode.linkStaffInfo ? QRCode.linkStaffInfo.realName : ''}
      </TableCell>

      <TableCell>
        {QRCode.useUserInfo ? QRCode.useUserInfo.realName : ''}
      </TableCell>

      <TableCell>
        {QRCode.useDate && moment(QRCode.useDate).format('YYYY-MM-DD')}
      </TableCell>

      <TableCell>
        {QRCode.useStaffInfo ? QRCode.useStaffInfo.realName : ''}
      </TableCell>

      <TableCell>{moment(QRCode.createdDate).format('YYYY-MM-DD')}</TableCell>

      <TableCell>
        {QRCode.createStaffInfo ? QRCode.createStaffInfo.realName : ''}
      </TableCell>

      <TableCell align="right">
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<SystemUpdateAltRoundedIcon />}
          disabled={isLoading}
          style={{ marginRight: '12px' }}
          onClick={handleDownloadQRCode}>
          下載 QRCode
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default BonusProductQRCodeTableRow;
